import { array, boolean, defineAction, object, string } from '~/prix'
import updateMonitorUserPermissions from './updateMonitorUserPermissions.action.json'

const updateMonitorUserPermissionsDefinition = defineAction({
  ...updateMonitorUserPermissions,
  input: object({
    permissionKeys: array(string()),
    receiveWeeklyInsightsEmail: boolean(),
  }),
  output: object({}),
})

export default updateMonitorUserPermissionsDefinition
